/* afzuigkapSpecialist.nl: afstandsbediening-simulatie (pure JS, geen libs) */
(function () {
  'use strict';
  if (window.__waveRemote) return;
  window.__waveRemote = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var LEVELS = [0, 0.35, 0.7, 1];
  var SEQ = [
    ['power', 1200], ['speedUp', 1300], ['speedUp', 1200], ['speedDown', 1500],
    ['light', 1700], ['dimDown', 1200], ['dimDown', 1100], ['dimUp', 1300],
    ['dimUp', 1200], ['light', 1900], ['power', 1700]
  ];

  function init(root) {
    if (root.__wr) return;
    root.__wr = true;
    root.classList.add('is-js');

    var st = { hood: 0, last: 1, light: false, dim: 3 };
    var buttons = root.querySelectorAll('[data-act]');
    var dots = root.querySelectorAll('.wr-dot');
    var bars = root.querySelectorAll('.wr-bar');
    var leds = root.querySelectorAll('.wr-hled');
    var led = root.querySelector('.wr-led');
    var hoodText = root.querySelector('[data-wr-hood]');
    var lightText = root.querySelector('[data-wr-light]');
    var toggle = root.querySelector('[data-wr-toggle]');
    var powerBtn = root.querySelector('[data-act="power"]');
    var lightBtn = root.querySelector('[data-act="light"]');
    var i = 0, timer = null, visible = false, userPaused = reduce, demoOn = false;

    function render() {
      root.setAttribute('data-hood', String(st.hood));
      root.setAttribute('data-light', st.light ? 'on' : 'off');
      root.style.setProperty('--lv', st.light ? String(LEVELS[st.dim]) : '0');
      for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('on', d < st.hood);
      for (var l = 0; l < leds.length; l++) leds[l].classList.toggle('on', l < st.hood);
      for (var b = 0; b < bars.length; b++) bars[b].classList.toggle('on', st.light && b < st.dim);
      if (hoodText) hoodText.textContent = st.hood ? 'Stand ' + st.hood : 'Uit';
      if (lightText) lightText.textContent = st.light ? 'Aan, ' + Math.round(LEVELS[st.dim] * 100) + '%' : 'Uit';
      if (powerBtn) powerBtn.setAttribute('aria-pressed', st.hood ? 'true' : 'false');
      if (lightBtn) lightBtn.setAttribute('aria-pressed', st.light ? 'true' : 'false');
    }

    function act(name) {
      if (name === 'power') {
        if (st.hood) { st.last = st.hood; st.hood = 0; } else { st.hood = st.last || 1; }
      } else if (name === 'speedUp') {
        st.hood = st.hood ? Math.min(3, st.hood + 1) : 1;
      } else if (name === 'speedDown') {
        if (st.hood > 1) st.hood -= 1;
      } else if (name === 'light') {
        st.light = !st.light;
      } else if (name === 'dimUp') {
        if (!st.light) st.light = true; else st.dim = Math.min(3, st.dim + 1);
      } else if (name === 'dimDown') {
        if (st.light) st.dim = Math.max(1, st.dim - 1);
      }
      render();
    }

    function press(name) {
      var el = root.querySelector('[data-act="' + name + '"]');
      if (el) {
        el.classList.remove('is-pressed');
        void el.getBoundingClientRect();
        el.classList.add('is-pressed');
        setTimeout(function () { el.classList.remove('is-pressed'); }, 650);
      }
      if (led && !reduce) {
        led.classList.remove('flash');
        void led.getBoundingClientRect();
        led.classList.add('flash');
      }
      setTimeout(function () { act(name); }, reduce ? 0 : 140);
    }

    function stop() {
      clearTimeout(timer);
      timer = null;
      demoOn = false;
    }

    function tick() {
      clearTimeout(timer);
      if (userPaused || !visible || document.hidden) { demoOn = false; return; }
      demoOn = true;
      var step = SEQ[i];
      timer = setTimeout(function () {
        press(step[0]);
        i = (i + 1) % SEQ.length;
        tick();
      }, step[1] + (i === 0 ? 900 : 0));
    }

    function resetState() {
      st.hood = 0; st.last = 1; st.light = false; st.dim = 3; i = 0;
      render();
    }

    function setToggle() {
      if (!toggle) return;
      toggle.textContent = userPaused ? 'Speel demo af' : 'Pauzeer demo';
      toggle.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
    }

    // Zelf bedienen: klik, Enter of spatie
    Array.prototype.forEach.call(buttons, function (btn) {
      function go(e) {
        if (e) e.preventDefault();
        if (!userPaused) { userPaused = true; stop(); setToggle(); }
        press(btn.getAttribute('data-act'));
      }
      btn.addEventListener('click', go);
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') go(e);
      });
    });

    if (toggle) {
      if (reduce) toggle.hidden = true;
      toggle.addEventListener('click', function () {
        if (userPaused) {
          userPaused = false;
          resetState();
          setToggle();
          tick();
        } else {
          userPaused = true;
          stop();
          setToggle();
        }
      });
    }

    if (reduce) {
      // Geen autoplay: statisch voorbeeld (stand 2, licht op 70%), zelf te bedienen
      st.hood = 2; st.last = 2; st.light = true; st.dim = 2;
    }
    render();
    setToggle();

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else tick();
    });

    function onVisible(v) {
      visible = v;
      root.classList.toggle('is-live', v && !reduce);
      if (v) { if (!demoOn) tick(); } else { stop(); }
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        onVisible(entries[0].isIntersecting);
      }, { threshold: 0.35 });
      io.observe(root);
    } else {
      onVisible(true);
    }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-wr]');
    for (var r = 0; r < roots.length; r++) init(roots[r]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
